module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Kurse")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('span', {
    staticClass: "is-small"
  }, [_vm._v("Geldkurs Produkt")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "has-text-weight-bold",
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.currency(_vm.productPriceBid, _vm.productCurrency))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('span', {
    staticClass: "is-small"
  }, [_vm._v("Brief Produkt")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "has-text-weight-bold",
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.currency(_vm.productPriceAsk, _vm.productCurrency))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('span', {
    staticClass: "is-small"
  }, [_vm._v("Kurs Basiswert")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "has-text-weight-bold",
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.currency(_vm.underlyingPrice, _vm.underlyingCurrency))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('span', {
    staticClass: "is-small"
  }, [_vm._v("Zeitpunkt")]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "has-text-weight-bold",
    domProps: {
      "innerHTML": _vm._s(this.$options.filters.date(_vm.underlyingTimestamp, 'DD.MM.YYYY HH:mm:ss'))
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e199ab6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/factsheet/ReportBaseFigures.vue
// module id = 670
// module chunks = 0